import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPayment.Find.IRequest;
type Response = Api.Finance.ContractRefundPayment.Find.IResponse;
type Headers = Api.Finance.ContractRefundPayment.Find.IHeaders;
const url = '/api/Finance/ContractRefundPayment/:id';
export default async function contractRefundPaymentFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
